import React from 'react';
import ReactPaginate from 'react-paginate';

const Pagination = ({totalPages, initialPage, onPageChange}) => (
	totalPages > 1 ?
	<ReactPaginate
		pageCount={totalPages}
		pageRangeDisplayed={6}
		marginPagesDisplayed={2}
		initialPage={initialPage}
		onPageChange={onPageChange}
		containerClassName="woocommerce-pagination text-align-center"
		pageLinkClassName="page-numbers"
		activeClassName="current"
		previousLinkClassName="page-numbers"
		nextLinkClassName="page-numbers"
	/>
	: null
);

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Pagination/index.js